export class ReCaptchaData {
    getSiteKey() {
        return "6Lf2yvgaAAAAAGFhyu9KnSW7Bd9cMnDS27ohB84J";
    }
}

const reCaptchaData = new ReCaptchaData();
export default reCaptchaData;
